import * as React from 'react';
import bin from '../../../images/bin.svg';

const DeleteButton = ({ onClick }: Props) => (
	<button title="Delete" className="deleteButton iconButton deleteIcon" type="button" onClick={onClick}>
		<img src={bin} alt="Delete Icon" />
	</button>
);

interface Props {
	onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

export default DeleteButton;
